"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _selectInput = _interopRequireDefault(require("../selectInput/selectInput"));

var _button = _interopRequireDefault(require("../button/button"));

var _loader = _interopRequireDefault(require("../loader/loader"));

var _lodash = _interopRequireDefault(require("lodash"));

var _tableModule = _interopRequireDefault(require("./table.module.css"));

var _classnames = _interopRequireDefault(require("classnames"));

var _horizontalRule = _interopRequireDefault(require("../horizontalRule/horizontalRule"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactI18next = require("react-i18next");

var _resourceKeys = require("../providers/translations/resources/resourceKeys");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var SelectableActionsForm = function SelectableActionsForm(props) {
  var id = props.id,
      selectedAction = props.selectedAction,
      onSelectAction = props.onSelectAction,
      selectActions = props.selectActions,
      selected = props.selected,
      onSelectedActionApply = props.onSelectedActionApply,
      actionResultLoading = props.actionResultLoading,
      hideHorizontalRuleOfActions = props.hideHorizontalRuleOfActions;

  var _useTranslation = (0, _reactI18next.useTranslation)(),
      t = _useTranslation.t,
      i18n = _useTranslation.i18n;

  return _react.default.createElement(_react.default.Fragment, null, !hideHorizontalRuleOfActions && _react.default.createElement(_horizontalRule.default, {
    id: id ? "".concat(id, "_hr") : null
  }), _react.default.createElement("form", {
    id: id ? "".concat(id, "_form") : null,
    className: (0, _classnames.default)(_tableModule.default["form-inline"], _tableModule.default["form-group"])
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_form_group") : null,
    className: _tableModule.default["form-group"]
  }, _react.default.createElement("div", {
    id: id ? "".concat(id, "_input_wrapper") : null,
    className: _tableModule.default["selectWrapper"]
  }, _react.default.createElement(_selectInput.default, {
    id: id ? "".concat(id, "_input") : null,
    className: _tableModule.default["form-control"],
    value: selectedAction,
    name: "selectedAction",
    onChange: onSelectAction,
    options: [{
      key: "",
      label: t(_resourceKeys.resourceKeys.selectAction.key)
    }].concat(_toConsumableArray(selectActions.map(function (action) {
      return {
        key: action.key,
        label: action.label
      };
    })))
  }))), _react.default.createElement("div", {
    id: id ? "".concat(id, "_button_wrapper") : null,
    className: _tableModule.default["form-group"]
  }, _react.default.createElement(_button.default, {
    id: id ? "".concat(id, "_button") : null,
    variant: "primary",
    arrowDirection: "right",
    label: t(_resourceKeys.resourceKeys.apply.key),
    type: "button",
    onClick: onSelectedActionApply,
    disabled: _lodash.default.size(selected) === 0 || !selectedAction
  }), actionResultLoading && _react.default.createElement(_loader.default, {
    id: id ? "".concat(id, "_loader") : null,
    variant: "inline",
    label: t(_resourceKeys.resourceKeys.loading.key)
  }))));
};

SelectableActionsForm.propTypes = {
  /** String text that specifies a unique id for an HTML element. Consistent Id type: snake_case*/
  id: _propTypes.default.string,

  /** Selected key from options. Similar with the SelectInput component */
  selectedAction: _propTypes.default.oneOf([_propTypes.default.number, _propTypes.default.string]),

  /** Callback fired when the user selects an action. Similar with the onChange callback of the SelectInput
   * component*/
  onSelectAction: _propTypes.default.func,

  /** Array of options like the SelectInput component*/
  selectActions: _propTypes.default.array,

  /** Object containing the selected items */
  selected: _propTypes.default.object,

  /** Callback invoked when the user triggers an action */
  onSelectedActionApply: _propTypes.default.func,

  /** Boolean indicating the the action execution is loading*/
  actionResultLoading: _propTypes.default.bool,

  /** flag that indicates if the horizontal rule should be hidden between actions and view select item */
  hideHorizontalRuleOfActions: _propTypes.default.bool
};
var _default = SelectableActionsForm;
exports.default = _default;